module.exports = __webpack_public_path__ + "static/assets/19265229c3e6585a7e173f09558285b2.svg";